import { render } from "./TopFooter.vue?vue&type=template&id=2c680ef7&scoped=true"
import script from "./TopFooter.vue?vue&type=script&lang=js"
export * from "./TopFooter.vue?vue&type=script&lang=js"

import "./TopFooter.vue?vue&type=style&index=0&id=2c680ef7&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c680ef7"]])

export default __exports__